import formatLanguage from './format-language';

export { formatLanguage };

export default formatLanguage;
